import React, { useState, useEffect } from "react"
import { Table, message } from "antd" // Assuming you're using Ant Design for message handling
import axiosInstance from "../../../axios/axiosConfig"

function KnivesList() {
  const [filteredKnives, setFilteredKnives] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [knivesLoaded, setKnivesLoaded] = useState(0)

  useEffect(() => {
    const fetchKnives = async () => {
      try {
        const response = await axiosInstance.get("/api/production")
        if (response && response.data) {
          filterKnives(response.data)

          setIsLoading(false)
          console.log(response.data)
        } else {
          message.error("No knives data found!")
          setIsLoading(false)
        }
      } catch (error) {
        console.error("Failed to fetch knives:", error)
        setError(error.message)
        setIsLoading(false)
        message.error("Failed to fetch knives data")
      }
    }

    fetchKnives()
  }, [])

  const CHUNK_SIZE = 50 // Define the number of knives to update per batch

  const updateKnives = async () => {
    try {
      // Map through each knife and set VIVA_340_Minimal_paper_width_160mm based on conditions
      const knivesToUpdate = filteredKnives.map((knife) => ({
        ...knife,
        VIVA_340_Minimal_paper_width_160mm:
          knife.Knives_WIDTH_mm >= 150 &&
          knife.Knives_WIDTH_mm <= 330 &&
          knife.Z_raports >= 150 &&
          knife.Z_raports <= 304.8,
      }))

      // Process in batches
      for (let i = 0; i < knivesToUpdate.length; i += CHUNK_SIZE) {
        const chunk = knivesToUpdate.slice(i, i + CHUNK_SIZE)
        const response = await axiosInstance.post("/api/updateKnives", { knives: chunk })

        if (response.data) {
          console.log(`Updated batch ${Math.floor(i / CHUNK_SIZE) + 1} successfully`)
        }
      }

      message.success("All knives updated successfully")
      setFilteredKnives(knivesToUpdate) // Update local state with new values
    } catch (error) {
      console.error("Failed to update knives:", error)
      message.error("Failed to update knives")
    }
  }

  const filterKnives = (knivesData) => {
    const rangeFilter = knivesData.filter(
      (knife) =>
        // // (knife.Knives_WIDTH_mm >= 150 && knife.Knives_WIDTH_mm <= 330) ||
        // // (knife.Z_raports >= 150 && knife.Z_raports <= 304.8) ||
        !knife.VIVA_340_Minimal_paper_width_160mm
    )
    // const rangeFilter = knivesData

    // Logging for debugging
    console.log("Filtered knives:", rangeFilter)

    const knivesLength = rangeFilter.length
    console.log("Knives length after filtering:", knivesLength)

    setFilteredKnives(rangeFilter)
    setKnivesLoaded(knivesLength)
  }

  if (isLoading) return <div>Loading...</div>
  if (error) return <div>Error: {error}</div>

  const knifeCols = [
    {
      title: "code",
      dataIndex: "code",
    },
    {
      title: "knives width mm",
      dataIndex: "Knives_WIDTH_mm",
    },
    {
      title: "Z raport",
      dataIndex: "Z_raports",
    },
    {
      title: "Viva",
      dataIndex: "VIVA_340_Minimal_paper_width_160mm",
      render: (value) => {
        if (value) {
          return "yes"
        } else {
          return "no"
        }
      },
    },
  ]

  return (
    <div>
      <h1>Knives List</h1>
      <h1>amount {knivesLoaded}</h1>
      <button onClick={() => updateKnives(filteredKnives)}>log</button>
      <Table
        loading={isLoading}
        dataSource={filteredKnives}
        columns={knifeCols}
        rowKey={(record) => record.id}
      />
    </div>
  )
}

export default KnivesList
